'use client';
import React, { useEffect, useRef } from 'react';

const StoreLocator = () => {
  const storeLocatorScriptLoaded = useRef(false);

  useEffect(() => {
    if (storeLocatorScriptLoaded.current) {
      return;
    }

    // Optimistically assumes that loading the script went well.
    storeLocatorScriptLoaded.current = true;

    // Script tag is added in this manner to avoid the store locator being subject to the NextJS rendering cycle.
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://www.storemapper.co/js/widget.js';
    script.setAttribute('data-storemapper-id', '10547');
    script.setAttribute('data-storemapper-start', '2021,05,04');

    const storemapperElement = document.querySelector('#storemapper');
    if (!storemapperElement) {
      return;
    }

    storemapperElement.insertAdjacentElement('beforeend', script);
  }, []);

  return <div id="storemapper" style={{ width: '100%' }} />;
};

export default React.memo(StoreLocator);
